export default "__VITE_ASSET__e236adf1__"